/**
 * Various methods to retrieve localized values and similar information.
 */
export class ResHelper {
    /**
     * Get the localized value for the given key or null/undefined if it does not exist.
     * @param key localization key
     */
    public static getString(key: string): string | undefined {
        if (!key) {
            return undefined;
        }

        // resourceDictionary is defined in _Layout.cshtml
        return (window as any).formula.localization.resourceDictionary[key];
    }

    /**
     * Get a localized string for the key or when not available return the fallback.
     * @param key localization key
     * @param fallback value to return as fallback
     */
    public static getStringOrFallback(key: string, fallback: string): string {
        const value = this.getString(key);
        return value == null ? fallback : value;
    }

    /**
     * Get a localized string for the key or when not available use the fallback key to get a value.
     * @param key localization key
     * @param fallbackKey fallback localization key
     */
    public static getStringOrUseFallbackKey(key: string, fallbackKey: string): string | undefined {
        const value = this.getString(key);
        return value == null ? this.getString(fallbackKey) : value;
    }

    /**
     * Retrieves a localized string for the key and replaces the placeholders with the given parameters.
     * @param key localization key
     * @param params parameters that should be used instead of the placeholders
     */
    public static getStringWithParameters(key: string, ...params: string[]): string | undefined {
        let value = this.getString(key);
        if (!value) {
            return undefined;
        }

        params.forEach((p, i) => value = value && value.replace(`{${i + 1}}`, p));
        return value;
    }

    /**
     * Get the name of the current culture.
     */
    public static getCurrentCultureName(): string {
        // currentCultureName is defined in _Layout.cshtml
        return (window as any).formula.localization.currentCultureCode;
    }
}
